<template>
  <div class="content2">
    <vue-headful
    title="Dashboard | Business Cards"
    description="Dashboard | Business Cards"
/>

<div v-if="loading_business_cards" style="margin: 0 auto;">
  <center>
  <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
  <p class="lead">Loading...</p>
  </center>
</div>


<div v-if="!loading_business_cards" class="sc-bvTASY jPMoWD">
  <div class="sc-cFlXAS WflZx">
      <div v-if="business_cards !== null && business_cards.length > 0" class="row">
        <div v-for="(business_card, index) in business_cards" class="blog-card col-12 col-lg-6">
            <div class="card shadow-soft border-light">
                <div style="position: absolute; right: 0px;" class="show">
                  <button @click="open_dropdown(index)" class="btn btn-sm btn-light" style="border-radius: 0px;">
                    <span class="icon icon-sm">
                      <span class="fas fa-ellipsis-h icon-dark"></span>
                    </span>
                    <span class="sr-only">Toggle Dropdown</span>
                  </button>
                  <div v-if="dropdown === index" v-click-outside="close_dropdown" style="position: absolute;will-change: transform;top: -12px;left: -68px;transform: translate3d(0px, 42px, 0px);background-color: #ffffff;padding: 0.7rem 0;margin: 0.125rem 0 0;font-size: 0.875rem;z-index: 1000;border: 0 solid rgba(36, 38, 43, 0.15);border-radius: 0.2rem;box-shadow: 0 1rem 3rem rgba(13, 20, 49, 0.175);line-height: 1.5;">
                    <a @click="open_modal_delete(index)" class="dropdown-item text-danger" style="padding: .5rem 1rem;font-size: 0.875rem;">
                      <i class="fa-solid fa-trash-can mr-2"></i> Delete
                    </a>
                  </div>
                </div>
                <div :id="'businesscard-'+index" class="card-body p-0 pb-3">
                    <!-- TEMPLATE 1 -->
                    <svg v-if="business_card.template === '1'" :id="'svgFront-'+business_card.unique_id" xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                            <!-- Background -->
                            <rect x="0" y="0" width="222" height="250" fill="white"></rect>
                            <rect x="222" y="0" width="278" height="250" :fill="business_card.background_color"></rect>

                            <!-- Logo -->
                            <defs>
                                <clipPath id="roundedClip">
                                <rect x="16" y="30" width="190" height="190" rx="5" ry="5"></rect>
                                </clipPath>
                            </defs>

                            <image :href="business_card.logo_base64" height="190" width="190" y="30" x="16" clip-path="url(#roundedClip)"></image>

                            <g :ref="'textGroup-'+index" :transform="calculateGroupTransform(index)">
                                <!-- Name -->
                                <text v-if="business_card.name" x="235" y="0" font-family="Arial" :font-size="calculateFontSize(business_card.name, 24)" :fill="business_card.name_color">{{business_card.name}}</text>

                                <!-- Role -->
                                <text v-if="business_card.role" x="235" :y="getYPosition(index, 'role')" font-family="Arial" :font-size="calculateFontSize(business_card.role, 18)" :fill="business_card.role_color">{{business_card.role}}</text>

                                <!-- Phone -->
                                <text v-if="business_card.phone" x="235" :y="getYPosition(index, 'phone')" font-family="Arial" :font-size="calculateFontSize(business_card.phone, 14)" :fill="business_card.phone_color">{{business_card.phone}}</text>

                                <!-- Email -->
                                <text v-if="business_card.email" x="235" :y="getYPosition(index, 'email')" font-family="Arial" :font-size="calculateFontSize(business_card.email, 14)" :fill="business_card.email_color">{{business_card.email}}</text>

                                <!-- Website -->
                                <text v-if="business_card.website" x="235" :y="getYPosition(index, 'website')" font-family="Arial" :font-size="calculateFontSize(business_card.website, 14)" :fill="business_card.website_color">{{business_card.website}}</text>

                                <!-- Address -->
                                <text v-if="business_card.address" x="235" :y="getYPosition(index, 'address')" font-family="Arial" :font-size="calculateFontSize(business_card.address, 14)" :fill="business_card.address_color">{{business_card.address}}</text>
                            </g>
                    </svg>
                    <!-- TEMPLATE 2 -->
                    <svg v-if="business_card.template === '2'" :id="'svgFront-'+business_card.unique_id" xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                            <!-- Background -->
                            <rect x="0" y="0" width="500" height="250" :fill="business_card.background_color"></rect>

                            <!-- Logo on the Right Side -->
                            <!-- Define the circle clip path -->
                            <defs>
                                <clipPath id="circleClip2">
                                <ellipse cx="400" cy="125" rx="73.5" ry="73.5"/>
                                </clipPath>
                            </defs>

                            <!-- Image with the circular clip path -->
                            <image :href="business_card.logo_base64" height="147" width="147" y="51.5" x="326.5" clip-path="url(#circleClip2)"></image>

                            <!-- Text elements -->
                            <g :ref="'textGroup-'+index" :transform="calculateGroupTransform(index)">
                                <text v-if="business_card.name" x="30" y="0" font-family="Arial" :font-size="calculateFontSize(business_card.name, 24)" :fill="business_card.name_color">{{business_card.name}}</text>
                                <text v-if="business_card.role" x="30" :y="getYPosition(index, 'role')" font-family="Arial" :font-size="calculateFontSize(business_card.role, 18)" :fill="business_card.role_color">{{business_card.role}}</text>
                                <text v-if="business_card.phone" x="30" :y="getYPosition(index, 'phone')" font-family="Arial" :font-size="calculateFontSize(business_card.phone, 14)" :fill="business_card.phone_color">{{business_card.phone}}</text>
                                <text v-if="business_card.email" x="30" :y="getYPosition(index, 'email')" font-family="Arial" :font-size="calculateFontSize(business_card.email, 14)" :fill="business_card.email_color">{{business_card.email}}</text>
                                <text v-if="business_card.website" x="30" :y="getYPosition(index, 'website')" font-family="Arial" :font-size="calculateFontSize(business_card.website, 14)" :fill="business_card.website_color">{{business_card.website}}</text>
                                <text v-if="business_card.address" x="30" :y="getYPosition(index, 'address')" font-family="Arial" :font-size="calculateFontSize(business_card.address, 14)" :fill="business_card.address_color">{{business_card.address}}</text>
                            </g>
                    </svg>
                    <!-- TEMPLATE 3 -->
                    <svg v-if="business_card.template === '3'" :id="'svgFront-'+business_card.unique_id" xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                            <!-- Background -->
                            <rect x="0" y="0" width="500" height="250" :fill="business_card.background_color"></rect>

                            <g transform="translate(470, 0) rotate(90)">
                                <!-- Logo on the Top Left Side -->
                                <!-- Define the circle clip path -->
                                <defs>
                                    <clipPath id="circleClip3">
                                    <ellipse cx="125" cy="100" rx="70" ry="70"/>
                                    </clipPath>
                                </defs>

                                <!-- Apply the circle clip path to the logo image -->
                                <image :href="business_card.logo_base64" height="140" width="140" y="30" x="55" clip-path="url(#circleClip3)"></image>

                                <!-- Text elements -->
                                <g :ref="'textGroup-'+index" transform="translate(0, 240)">
                                    <text v-if="business_card.name" x="125" y="0" font-family="Cursive" :font-size="calculateFontSize(business_card.name, 24)" :fill="business_card.name_color" text-anchor="middle">{{business_card.name}}</text>
                                    <text v-if="business_card.role" x="125" :y="getYPosition(index, 'role')" font-family="Arial" :font-size="calculateFontSize(business_card.role, 18)" :fill="business_card.role_color" text-anchor="middle">{{business_card.role}}</text>
                                    <text v-if="business_card.phone" x="125" :y="getYPosition(index, 'phone')" font-family="Arial" :font-size="calculateFontSize(business_card.phone, 14)" :fill="business_card.phone_color" text-anchor="middle">{{business_card.phone}}</text>
                                    <text v-if="business_card.email" x="125" :y="getYPosition(index, 'email')" font-family="Arial" :font-size="calculateFontSize(business_card.email, 14)" :fill="business_card.email_color" text-anchor="middle">{{business_card.email}}</text>
                                    <text v-if="business_card.website" x="125" :y="getYPosition(index, 'website')" font-family="Arial" :font-size="calculateFontSize(business_card.website, 14)" :fill="business_card.website_color" text-anchor="middle">{{business_card.website}}</text>
                                    <text v-if="business_card.address" x="125" :y="getYPosition(index, 'address')" font-family="Arial" :font-size="calculateFontSize(business_card.address, 14)" :fill="business_card.address_color" text-anchor="middle">{{business_card.address}}</text>
                                </g>
                            </g>
                    </svg>
                    <!-- Back of Business Card -->
                    <div class="offscreen">
                        <svg :id="'svgBack-'+business_card.unique_id" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 250" preserveAspectRatio="xMidYMid meet">
                            <!-- Background -->
                            <rect x="0" y="0" width="500" height="250" :fill="business_card.background_color"></rect>

                            <!-- Define the circular clip path -->
                            <defs>
                                <clipPath id="circleClip1">
                                <ellipse cx="250" cy="125" rx="73.5" ry="73.5"></ellipse>
                                </clipPath>
                            </defs>

                            <!-- Image centered within the SVG -->
                            <image :href="business_card.logo_base64" height="147" width="147" y="51.5" x="176.5" clip-path="url(#circleClip1)"></image>
                        </svg>
                    </div>
                </div>
                <div class="card-footer mx-4 px-0 pt-0">
                  <div class="d-flex justify-content-center">
                    <div v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="col-6 mr-2 p-0">
                        <button data-toggle="modal" data-target="#modal-business-cards" class="btn btn-blue w-100">
                            Download
                        </button>
                    </div>
                    <div v-else class="col-6 mr-2 p-0">
                        <button class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Download
                        </button>
                        <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                            <a @click="downloadPngFile(business_card.unique_id)" class="dropdown-item">PNG</a>
                            <a @click="downloadSvgFile(business_card.unique_id)" class="dropdown-item">SVG</a>
                            <a @click="downloadPdfFile(business_card.unique_id)" class="dropdown-item">PDF</a>
                        </div>
                    </div>
                    <div class="col-6 ml-2 p-0">
                        <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-light w-100" data-toggle="modal" data-target="#modal-business-cards">
                            Edit business card
                        </button>
                        <router-link v-else :to="'/dashboard/edit-business-card/'+business_card.unique_id" class="btn btn-light w-100">
                            Edit business card
                        </router-link>                        
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div v-else>
        <div class="row row-grid align-items-center">
          <div class="col-12 col-lg-5">
            <h2 class="font-weight-bolder mb-4">Business Card Maker</h2>
            <p>Get custom business card designs that are already branded with your logo and business information.</p>
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-primary mt-3 animate-up-2" data-toggle="modal" data-target="#modal-business-cards">
                Create your business card
            </button>
            <router-link v-else to="/dashboard/create-business-card" class="btn btn-primary mt-3 animate-up-2">Create your business card</router-link>
          </div>
          <div class="col-12 col-lg-6 ml-lg-auto">
            <img src="https://logo.app/assets/img/business-card-maker.png" alt="image" style="border-radius: 5px;">
          </div>
        </div>
      </div>
  </div>
</div>

<!-- DELETE BUSINESS CARD MODAL -->
<div v-if="business_card_to_delete !== ''" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
    <div v-click-outside="close_modal_delete" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header w-100">
          <p class="lead mb-0">Delete business card</p>
          <button @click="close_modal_delete" type="button" class="close ml-auto" style="position: absolute; right: 21px;">
          <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="mb-0">Are you sure you want to delete your business card?<br>This action is irreversible and cannot be undone.</p>
        </div>
        <div class="modal-footer">
            <button @click="close_modal_delete" class="btn btn-light mr-auto">Cancel</button>
            <button @click="delete_business_card" class="btn btn-danger">Delete</button>
        </div>
      </div>
    </div>
</div>

</div>

</template>

<style>
a {
  color: #515151;
}
.delete_btnhover:hover{
  color: #ee5150!important;
}
.preview_btnhover:hover{
  color: #073482!important;
}
.downloads_btnhover:hover{
  color: #073482!important;
}

/* Off-screen CSS */
.offscreen {
  position: absolute;
  visibility: hidden; /* The element is not visible, but it is still rendered */
  width: 1px;         /* Minimize the element size */
  height: 1px;
  overflow: hidden;   /* Ensure that no part of the element spills over */
  left: 0;            /* Position it at the top-left corner to avoid any layout issues */
  top: 0;
}
</style>

  <script>
  import ClickOutside from 'vue-click-outside';

  export default {
    props:['propsdata'],
    data() {
      return {
        timenow: Date.now(),
        loading_business_cards: true,
        business_cards: [],
        dropdown: 'closed',
        business_card_to_delete: ''
      };
    },
    methods: {
        downloadSvgFile(unique_id) {
            // Get the front SVG element by ID
            const svgFrontElement = document.getElementById('svgFront-' + unique_id);

            // Check if the front SVG element exists
            if (svgFrontElement) {
                // Clone the SVG element to avoid altering the original
                const svgFrontClone = svgFrontElement.cloneNode(true);

                // Remove the preserveAspectRatio attribute
                svgFrontClone.removeAttribute("preserveAspectRatio");

                // Add width and height attributes
                svgFrontClone.setAttribute("width", "500");
                svgFrontClone.setAttribute("height", "250");

                // Get the SVG code as a string
                const svgFrontCode = svgFrontClone.outerHTML;

                // Create a Blob from the SVG code
                const blobFront = new Blob([svgFrontCode], { type: 'image/svg+xml' });

                // Create a URL for the Blob
                const urlFront = URL.createObjectURL(blobFront);

                // Create a temporary link element
                const downloadLinkFront = document.createElement('a');

                // Set the download attribute with a filename for the front SVG
                downloadLinkFront.download = 'business-card-front-' + unique_id + '.svg';

                // Set the href attribute to the Blob URL
                downloadLinkFront.href = urlFront;

                // Append the link to the document body (required for Firefox)
                document.body.appendChild(downloadLinkFront);

                // Programmatically click the link to trigger the download
                downloadLinkFront.click();

                // Clean up by removing the link and revoking the Blob URL
                document.body.removeChild(downloadLinkFront);
                URL.revokeObjectURL(urlFront);
            } else {
                console.error('SVG element with ID svgFront-' + unique_id + ' not found.');
            }

            // Get the back SVG element by ID
            const svgBackElement = document.getElementById('svgBack-' + unique_id);

            // Check if the back SVG element exists
            if (svgBackElement) {
                // Clone the SVG element to avoid altering the original
                const svgBackClone = svgBackElement.cloneNode(true);

                // Remove the preserveAspectRatio attribute
                svgBackClone.removeAttribute("preserveAspectRatio");

                // Add width and height attributes
                svgBackClone.setAttribute("width", "500");
                svgBackClone.setAttribute("height", "250");

                // Get the SVG code as a string
                const svgBackCode = svgBackClone.outerHTML;

                // Create a Blob from the SVG code
                const blobBack = new Blob([svgBackCode], { type: 'image/svg+xml' });

                // Create a URL for the Blob
                const urlBack = URL.createObjectURL(blobBack);

                // Create a temporary link element
                const downloadLinkBack = document.createElement('a');

                // Set the download attribute with a filename for the back SVG
                downloadLinkBack.download = 'business-card-back-' + unique_id + '.svg';

                // Set the href attribute to the Blob URL
                downloadLinkBack.href = urlBack;

                // Append the link to the document body (required for Firefox)
                document.body.appendChild(downloadLinkBack);

                // Programmatically click the link to trigger the download
                downloadLinkBack.click();

                // Clean up by removing the link and revoking the Blob URL
                document.body.removeChild(downloadLinkBack);
                URL.revokeObjectURL(urlBack);
            } else {
                console.error('SVG element with ID svgBack-' + unique_id + ' not found.');
            }
        },
        downloadPngFile(unique_id) {
            // Helper function to download SVG as PNG
            const downloadSvgAsPng = (svgElement, fileName, width, height) => {
                if (svgElement) {
                    // Clone the SVG element to avoid altering the original
                    const svgClone = svgElement.cloneNode(true);

                    // Remove the preserveAspectRatio attribute
                    svgClone.removeAttribute("preserveAspectRatio");

                    // Add width and height attributes
                    svgClone.setAttribute("width", "500");
                    svgClone.setAttribute("height", "250");

                    // Get the SVG code as a string
                    const svgCode = svgClone.outerHTML;

                    // Create an image element
                    const img = new Image();

                    // Create a Blob from the SVG code
                    const blob = new Blob([svgCode], { type: 'image/svg+xml' });

                    // Create a URL for the Blob
                    const url = URL.createObjectURL(blob);

                    // Set the image source to the Blob URL
                    img.src = url;

                    // Wait for the image to load
                    img.onload = () => {
                        // Create a canvas element
                        const canvas = document.createElement('canvas');

                        // Set the canvas dimensions to the desired size
                        canvas.width = width;
                        canvas.height = height;

                        // Draw the image onto the canvas with the specified dimensions
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, width, height);

                        // Convert the canvas to a data URL in PNG format
                        const pngUrl = canvas.toDataURL('image/png');

                        // Create a temporary link element
                        const downloadLink = document.createElement('a');

                        // Set the download attribute with a filename
                        downloadLink.download = fileName;

                        // Set the href attribute to the PNG data URL
                        downloadLink.href = pngUrl;

                        // Append the link to the document body (required for Firefox)
                        document.body.appendChild(downloadLink);

                        // Programmatically click the link to trigger the download
                        downloadLink.click();

                        // Clean up by removing the link and revoking the Blob URL
                        document.body.removeChild(downloadLink);
                        URL.revokeObjectURL(url);
                    };
                } else {
                    console.error('SVG element with ID ' + fileName + ' not found.');
                }
            };

            // Set default dimensions for business card
            const width = 1000;
            const height = 500;

            // Download the front SVG as PNG
            const svgFrontElement = document.getElementById('svgFront-' + unique_id);
            downloadSvgAsPng(svgFrontElement, 'business-card-front-' + unique_id + '.png', width, height);

            // Download the back SVG as PNG
            const svgBackElement = document.getElementById('svgBack-' + unique_id);
            downloadSvgAsPng(svgBackElement, 'business-card-back-' + unique_id + '.png', width, height);
        },
        downloadPdfFile(unique_id) {
            const { jsPDF } = window.jspdf;

            // Assuming your SVG dimensions are known
            const width = 500;  // Width of your SVG content
            const height = 250; // Height of your SVG content

            // Create a new jsPDF instance with custom size
            const doc = new jsPDF({
                orientation: 'landscape',
                unit: 'pt', // Points, since we're specifying exact sizes
                format: [width, height] // Set the PDF size to match the SVG dimensions
            });

            const svg2pdfFunc = window.svg2pdf.default || window.svg2pdf.svg2pdf;

            // Convert and add the first page
            const svgPage1 = document.getElementById('svgFront-' + unique_id);
            if (svgPage1) {
                // Clone the SVG element to avoid altering the original
                const svgPage1Clone = svgPage1.cloneNode(true);

                // Remove the preserveAspectRatio attribute
                svgPage1Clone.removeAttribute("preserveAspectRatio");

                // Add width and height attributes
                svgPage1Clone.setAttribute("width", "500");
                svgPage1Clone.setAttribute("height", "250");

                svg2pdfFunc(svgPage1Clone, doc, {
                    xOffset: 0,
                    yOffset: 0,
                    scale: 1 // Scale at 1 ensures it fits perfectly
                }).then(() => {
                    // Add a new page with the same dimensions
                    doc.addPage([width, height]);

                    // Convert and add the second page
                    const svgPage2 = document.getElementById('svgBack-' + unique_id);
                    if (svgPage2) {
                        // Clone the SVG element to avoid altering the original
                        const svgPage2Clone = svgPage2.cloneNode(true);

                        // Remove the preserveAspectRatio attribute
                        svgPage2Clone.removeAttribute("preserveAspectRatio");

                        // Add width and height attributes
                        svgPage2Clone.setAttribute("width", "500");
                        svgPage2Clone.setAttribute("height", "250");

                        svg2pdfFunc(svgPage2Clone, doc, {
                            xOffset: 0,
                            yOffset: 0,
                            scale: 1
                        }).then(() => {
                            // Save the PDF with a unique filename
                            doc.save("business-card-" + unique_id + ".pdf");
                        }).catch(error => {
                            console.error('Error converting second page:', error);
                            console.log('There was an issue generating the second page of the PDF. Please try again.');
                        });
                    } else {
                        console.error('SVG element with ID svgBack-' + unique_id + ' not found.');
                    }
                }).catch(error => {
                    console.error('Error converting first page:', error);
                    console.log('There was an issue generating the first page of the PDF. Please try again.');
                });
            } else {
                console.error('SVG element with ID svgFront-' + unique_id + ' not found.');
            }
        },
        calculateFontSize(text, initialFontSize) {
            if(this.business_cards[0].template === '1'){
                var maxTextWidth = 230; // Maximum width for the text elements
            }
            else if(this.business_cards[0].template === '2'){
                var maxTextWidth = 255; // Maximum width for the text elements
            }
            else if(this.business_cards[0].template === '3'){
                var maxTextWidth = 180; // Maximum width for the text elements
            }
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            let tempText = document.createElementNS("http://www.w3.org/2000/svg", "text");
            tempText.setAttribute("font-family", "Arial");
            tempText.setAttribute("font-size", initialFontSize);
            tempText.textContent = text;
            svg.appendChild(tempText);
            document.body.appendChild(svg);
            
            let textWidth = tempText.getBBox().width;
            document.body.removeChild(svg);

            if (textWidth > maxTextWidth) {
                return (initialFontSize * maxTextWidth) / textWidth;
            } else {
                return initialFontSize;
            }
        },
        calculateGroupTransform(index) {
            this.$nextTick(() => {
                const group = this.$refs['textGroup-' + index][0];
                if (group) {
                    const svgHeight = 250;
                    const bbox = group.getBBox();
                    const offsetY = (svgHeight - bbox.height) / 2 - bbox.y;
                    group.setAttribute('transform', `translate(0, ${offsetY})`);
                }
            });

            // Return a neutral or default value to avoid issues
            return 'translate(0, 0)';
        },
        getYPosition(index, field) {
            const business_card = this.business_cards[index];
            let yPosition = 0;

            if (field === 'name') {
                return yPosition;
            }

            if (field === 'role') {
                if (business_card.name) {
                    yPosition += 30;
                }
                return yPosition;
            }

            if (field === 'phone') {
                if (business_card.name) {
                    yPosition += 30;
                }
                if (business_card.role) {
                    yPosition += 50;
                }
                return yPosition;
            }

            if (field === 'email') {
                if (business_card.name) {
                    yPosition += 30;
                }
                if (business_card.role) {
                    yPosition += 50;
                }
                if (business_card.phone) {
                    yPosition += 25;
                }
                return yPosition;
            }

            if (field === 'website') {
                if (business_card.name) {
                    yPosition += 30;
                }
                if (business_card.role) {
                    yPosition += 50;
                }
                if (business_card.phone) {
                    yPosition += 25;
                }
                if (business_card.email) {
                    yPosition += 25;
                }
                return yPosition;
            }

            if (field === 'address') {
                if (business_card.name) {
                    yPosition += 30;
                }
                if (business_card.role) {
                    yPosition += 50;
                }
                if (business_card.phone) {
                    yPosition += 25;
                }
                if (business_card.email) {
                    yPosition += 25;
                }
                if (business_card.website) {
                    yPosition += 25;
                }
                return yPosition;
            }

            return yPosition;
        },
        open_dropdown(index){
            this.dropdown = index;
        },
        close_dropdown(){
            this.dropdown = 'closed';
        },
        open_modal_delete(index){
            this.business_card_to_delete = index;
        },
        close_modal_delete(){
            this.business_card_to_delete = '';
        },
        delete_business_card(){
            axios.post('/dashboard/delete-business-card.php', {
            unique_id: this.business_cards[this.business_card_to_delete].unique_id
            })
            this.business_cards.splice(this.business_card_to_delete, 1);
            if(this.business_cards.length === 0){
            this.business_cards = null;
            }
            this.business_card_to_delete = '';
        }
    },
    mounted() {
        this.$emit('updatepath');
        axios.post('/dashboard/cargar-business-cards.php', {
        })
        .then(response => {
            this.business_cards = response.data;
            this.loading_business_cards = false;
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    // do not forget this section
directives: {
  ClickOutside
}
  };
  </script>



// WEBPACK FOOTER //
// src/business-cards.vue